import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=07bc394e&scoped=true&"
import script from "./NavButtons.vue?vue&type=script&lang=js&"
export * from "./NavButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavButtons.vue?vue&type=style&index=0&id=07bc394e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc394e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
